/**
 *  路由组件
 */
import React, { Component } from 'react'
import { Route } from 'react-router-dom'
import Demo from './../page/Home/Demo';
// import Menu from './../page/Menu/Menu';
import EditionManagement from '../subpage/EditionManagement/index';
import AddedReleaseManagement from '../subpage/AddedReleaseManagement/index';
import releaseDetails from '../subpage/releaseDetails/index';
import distributionManagement from '../subpage/distributionManagement/index';
import operationLog from '../subpage/operationLog/index';
import './router.css';

class Router extends Component {
    constructor(props) {
        super(props);
        this.state={
         
        }
      }
    

    render() {
        return (
            <div style={{padding:'0px 0px 0px 0px',overflowY: 'auto',width:'100%',height:'calc( 100vh - 48px )'}}>
                <Route exact path="/Home" component={Demo}/>
                <Route exact path="/EditionManagement" component={EditionManagement}/>
                <Route exact path="/distributionManagement" component={distributionManagement}/>
                <Route exact path="/operationLog" component={operationLog}/>
                <Route exact path="/EditionManagement/AddedReleaseManagement" component={AddedReleaseManagement}/>
                <Route exact path="/EditionManagement/releaseDetails/:id" component={releaseDetails}/>
                {/* <Route exact path="/Menulist" component={Menu}/> */}
            </div>
            
        )
    }
}

export default Router;